const addRecordResult = {
  tableConfig: {
    showCheckbox: true
  },
  queryList: [
    {
      name: 'year',
      label: '送审年份',
      notNull: true,
      component: 'select',
      request: {
        method: 'post',
        addr: '/school/schoolQuarter/getSchoolYearList',
        data: {},
        format: {
          value: 'auditYear',
          label: 'auditYear'
        }
      }
    },
    {
      name: 'quarter',
      label: '送审季度',
      notNull: true,
      component: 'select',
      componentAttr: {
        options: [
          {
            value: '第一季度',
            label: '第一季度'
          },
          {
            value: '第二季度',
            label: '第二季度'
          },
          {
            value: '第三季度',
            label: '第三季度'
          },
          {
            value: '第四季度',
            label: '第四季度'
          }
        ]
      }
    },
    {
      name: 'batchId',
      label: '批次',
      component: 'input'
    },
    {
      name: 'workName',
      label: '单位名称',
      component: 'input'
    },
    {
      name: 'academyName',
      label: '院系名称',
      notNull: true,
      component: 'select',
      request: {
        method: 'post',
        addr: '/school/schoolQuarter/getSchoolYearList',
        data: {},
        format: {
          value: 'auditYear',
          label: 'auditYear'
        }
      }
    },
    {
      name: 'schoolNo',
      label: '学号',
      component: 'input'
    },
    {
      name: 'authorName',
      label: '姓名',
      component: 'input'
    },
    {
      name: 'titleCn',
      label: '论文题目',
      component: 'input'
    }
  ],
  urlMap: {
    'select': {
      url: '/custom/sendPaper/list',
      data: {
        sendType: '{default.sendType}'
      }
    }
  },
  operList: [// 操作列表
  ],
  titles: [
    {
      name: 'year',
      label: '送审年份'
    },
    {
      name: 'quarter',
      label: '送审季度'
    },
    {
      name: 'batchId',
      label: '批次'
    },
    {
      name: 'unitName',
      label: '单位名称'
    },
    {
      name: 'academyName',
      label: '院系名称'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科'
    },
    {
      name: 'secondSubjectName',
      label: '二级学科'
    },
    {
      name: 'schoolNo',
      label: '学号'
    },
    {
      name: 'authorName',
      label: '姓名'
    },
    {
      name: 'titleCn',
      label: '论文题目'
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '补录',
          name: 'detail',
          kind: 'primary', // error
          type: 'router', // request, router, dialog, func
          addr: '/shell/custom/customerThesis/thesisOnlineReview?id={id}&degreeType={degreeType}&unitCode={unitCode}'
        }
      ]
    }
  ]
}
export default addRecordResult



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/customerThesis/addRecordResult.js